import Vue from 'vue'
import Vuex from 'vuex'
import {auth} from "./module/auth.module";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex)

const vuexStorage = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
  },
  mutations: {
    RESTORE_MUTATION: vuexStorage.RESTORE_MUTATION
  },
  plugins: [vuexStorage.plugin],
  actions: {
  },
  modules: {
    auth
  }
})
